import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export interface TranslatedItem {
  key: string;
  value: string;
}

@Injectable()
export class TranslateArrayService {

  constructor(private translate: TranslateService) { }

  instant(keys: string[], prefix: string = ''): Observable<TranslatedItem[]> {
    if (!keys || !keys.length) { return of([]); }

    const keysWithPrefix = prefix && prefix.length ? keys.map((k) => `${prefix}.${k}`) : keys;

    return this.translate.get(keysWithPrefix)
      .pipe(map(translations => {
        return Object.keys(translations).map((keyWithPrefix): TranslatedItem => {
          const onlyKey = keyWithPrefix.replace(`${prefix}.`, '');
          return {
            key: onlyKey,
            value: translations[keyWithPrefix]
          }
        }).sort((a: TranslatedItem, b: TranslatedItem) => a.value.localeCompare(b.value));
      }));
  }
}
